import {createSlice} from "@reduxjs/toolkit";

const initialLicensesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  licenseForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const licensesSlice = createSlice({
  name: "licenses",
  initialState: initialLicensesState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getLicenseById
    licenseFetched: (state, action) => {
      state.actionsLoading = false;
      state.licenseForEdit = action.payload.licenseForEdit;
      state.error = null;
    },
    // findLicenses
    licensesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createLicense
    licenseCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.license);
    },
    // updateLicense
    licenseUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.license.id) {
          return action.payload.license;
        }
        return entity;
      });
    },
    // deleteLicense
    licenseDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deleteLicenses
    licensesDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
  }
});
